module.exports = __webpack_public_path__ + "static/fonts/SCDream2.b9eb56f.woff";